/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const KpiStatus = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
} as const;
export type KpiStatus = typeof KpiStatus[keyof typeof KpiStatus];

